import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SvgLoaderComponent } from 'lib-base';

@Component({
  selector: 'app-token-enviado',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, SvgLoaderComponent],
  template: `
    <section>
      <p-dialog [(visible)]="displayDialog" [modal]="true" [autoZIndex]="true" [draggable]="false" [resizable]="false"
                [maximizable]="false" [closable]="false"
                [breakpoints]="{'2000px': '686px', '1900px': '686px', '1700px': '686px',
               '1400px': '686px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}">
        <ng-template pTemplate="content">
          <div class="flex flex-column gap-2 align-content-center align-items-center">
            <div>
              <svg-loader name="ico-token-ok"/>
            </div>
            <h1 class="font-bold color-blue-2 font-23 my-0 font-principal ">
              {{ translations.header }}
            </h1>
            <span class="app-text-gray font-13 mb-3 text-center mt-2" style="max-width:458px;">
                 {{ translations.subHeader }}
             </span>
            <div class="pb-2">
              <p-button [label]="translations.continuar" [rounded]="true" (onClick)="continuar()"/>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="footer">
        </ng-template>
      </p-dialog>
    </section>
  `,
  styleUrl: './token-enviado.component.scss'
})
export class TokenEnviadoComponent implements OnInit {
  @Output() onContinuar = new EventEmitter<void>();

  displayDialog = false;
  translations: any = {};

  constructor(private _t: TranslateService) { }

  ngOnInit() {
    this.translate();
  }

  private async translate(): Promise<void>{
    this.translations = await firstValueFrom(forkJoin({
      continuar: this._t.get('common.continuar'),
      header: this._t.get('components.app-token-enviado.header'),
      subHeader: this._t.get('components.app-token-enviado.sub-header')
    }));
  }

  showDialog() {
    this.displayDialog = true;
  }

  hideDialog() {
    this.displayDialog = false;
  }

  continuar() {
    this.onContinuar.emit();
  }
}
